import React, { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useModal } from 'components/modals/ModalContext';
import { useFetchData } from 'services/api/useFetchData';
import '../../style/scss/pdf-preview.scss';

interface DocumentPdfPreviewModalProps {
    itemId: number;
    layoutId: number;
    objectType: string;
}

// Shows the pdf of a proposal, order, invoice or job as html in a modal, rendered
// like the pdf layout example instead of generating the pdf itself
const DocumentPdfPreviewModal: React.FC<DocumentPdfPreviewModalProps> = ({ itemId, layoutId, objectType }) => {
    const { t } = useTranslation();
    const { revealModal } = useModal();
    const shadowRootRef = useRef<HTMLDivElement>(null);

    // Fetch the rendered html of the document
    const { response } = useFetchData({ apiUrl: `generate-document-html/${layoutId}/${itemId}` });

    // Put the html in a shadow root so the pdf styles stay isolated, then reveal the modal
    useEffect(() => {
        if (!shadowRootRef.current || !response?.html) return;
        const shadowRoot = shadowRootRef.current.shadowRoot ?? shadowRootRef.current.attachShadow({ mode: 'open' });
        shadowRoot.innerHTML = response.html;
        revealModal();
    }, [response]);

    return (
        <div className='document-pdf-preview-modal'>
            <h4>{t('button.preview_pdf_modal_title', { object_name: t(`${objectType}.general.object_name.singular`) })}</h4>
            <div className='pdf-preview-page' ref={shadowRootRef} />
        </div>
    );
};

export default DocumentPdfPreviewModal;
